<ion-avatar *ngIf="imageURL" [style.height]="size" [style.width]="size">
  <img alt="Silhouette of a person's head" [src]="imageURL" />
</ion-avatar>

<div
  *ngIf="!imageURL"
  class="initials-avatar"
  [style.line-height]="size"
  [style.height]="size"
  [style.min-height]="size"
  [style.width]="size"
  [style.min-width]="size"
>
  {{ avatarName }}
</div>
